import React from "react";
import Button from "../../atoms/button/button";
import ElementCourse from "../element-course/element-course";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import Slider from "react-slick";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

import "./grid-group.scss";

const GridGroup = (props: ReferenciaContenido) => {
  const gridData = props;

  /*const {
		title,
		contentCourses,
	  gtmMark,
	  redirectBtn,
	  titleBtn
	} = props;*/
  const { nombreCategoria } = props;
  const sliderSettings = {
    arrows: false,
    dots: true,
    infinite: false,
    speed: 200,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="m-grid-group">
      <h2 className="m-grid-group-text"> {gridData?.tituloGeneral}</h2>
      <div className="m-grid-group__cont">
        <div className="m-grid-group__dominant">
          <div>
            <img
              src={
                gridData?.referenciaPlantillaContenido[0]?.imagenPrincipal[0]
                  ?.file?.url
              }
              alt={
                gridData?.referenciaPlantillaContenido[0]?.imagenPrincipal[0]
                  ?.title
              }
            />
            <div className="m-grid-group__dominant-info">
              <p className={`m-grid-group__dominant-title`}>
                {gridData?.referenciaPlantillaContenido[0]?.tituloBanner}
              </p>
              <Button
                type={"link"}
                classname={`secondary`}
                text={gridData?.referenciaPlantillaContenido[0]?.tituloBoton}
                href={
                  gridData?.referenciaPlantillaContenido[0]?.redireccionBoton
                }
                isDisabled={false}
                gtmMark={`gtmRedDeAmor${normalizeTwoWords(
                  nombreCategoria
                )}${normalizeTwoWords(
                  gridData.tituloGeneral
                )}${normalizeTwoWords(
                  gridData?.referenciaPlantillaContenido[0]?.tituloBoton
                )}`}
              />
            </div>
          </div>
        </div>
        <div className="m-grid-group__others">
          <div className="m-grid-group__others-cont hide-on-mobile">
            <div>
              <ElementCourse
                title={gridData?.referenciaPlantillaContenido[1]?.tituloBanner}
                info={
                  JSON.parse(
                    gridData?.referenciaPlantillaContenido[1]?.descripcion?.raw
                  )?.content[0]?.content[0]?.value
                }
                imageSrc={
                  gridData?.referenciaPlantillaContenido[1]?.imagenPrincipal[0]
                    ?.gatsbyImageData
                }
                imageAlt={
                  gridData?.referenciaPlantillaContenido[1]?.imagenPrincipal[0]
                    ?.title
                }
                gtmMark={`gtmRedDeAmor${normalizeTwoWords(
                  nombreCategoria
                )}${normalizeTwoWords(
                  gridData.tituloGeneral
                )}${normalizeTwoWords(
                  gridData?.referenciaPlantillaContenido[1]?.tituloBanner
                )}`}
                linkTo={
                  gridData?.referenciaPlantillaContenido[1]?.redireccionBoton
                }
                date={
                  gridData?.referenciaPlantillaContenido[1]?.tituloDescripcion
                }
              />
              <ElementCourse
                title={gridData?.referenciaPlantillaContenido[2]?.tituloBanner}
                info={
                  JSON.parse(
                    gridData?.referenciaPlantillaContenido[2]?.descripcion.raw
                  )?.content[0]?.content[0]?.value
                }
                imageSrc={
                  gridData?.referenciaPlantillaContenido[2]?.imagenPrincipal[0]
                    ?.gatsbyImageData
                }
                imageAlt={
                  gridData?.referenciaPlantillaContenido[2]?.imagenPrincipal[0]
                    ?.title
                }
                gtmMark={`gtmRedDeAmor${normalizeTwoWords(
                  nombreCategoria
                )}${normalizeTwoWords(
                  gridData.tituloGeneral
                )}${normalizeTwoWords(
                  gridData?.referenciaPlantillaContenido[2]?.tituloBanner
                )}`}
                linkTo={
                  gridData?.referenciaPlantillaContenido[2]?.redireccionBoton
                }
                date={
                  gridData?.referenciaPlantillaContenido[2]?.tituloDescripcion
                }
              />
              <ElementCourse
                title={gridData?.referenciaPlantillaContenido[3]?.tituloBanner}
                info={
                  JSON.parse(
                    gridData?.referenciaPlantillaContenido[3]?.descripcion?.raw
                  )?.content[0]?.content[0]?.value
                }
                imageSrc={
                  gridData?.referenciaPlantillaContenido[3]?.imagenPrincipal[0]
                    ?.gatsbyImageData
                }
                imageAlt={
                  gridData?.referenciaPlantillaContenido[3]?.imagenPrincipal[0]
                    ?.title
                }
                gtmMark={`gtmRedDeAmor${normalizeTwoWords(
                  nombreCategoria
                )}${normalizeTwoWords(
                  gridData.tituloGeneral
                )}${normalizeTwoWords(
                  gridData?.referenciaPlantillaContenido[3]?.tituloBanner
                )}`}
                linkTo={
                  gridData?.referenciaPlantillaContenido[3]?.redireccionBoton
                }
                date={
                  gridData?.referenciaPlantillaContenido[3]?.tituloDescripcion
                }
              />
            </div>
          </div>
          <div className="show-on-mobile">
            <Slider {...sliderSettings} className="m-grid-group__slider">
              <ElementCourse
                title={gridData?.referenciaPlantillaContenido[1]?.tituloBanner}
                info={
                  JSON.parse(
                    gridData?.referenciaPlantillaContenido[1]?.descripcion?.raw
                  )?.content[0]?.content[0]?.value
                }
                imageSrc={
                  gridData?.referenciaPlantillaContenido[1]?.imagenPrincipal[0]
                    ?.gatsbyImageData
                }
                imageAlt={
                  gridData?.referenciaPlantillaContenido[1]?.imagenPrincipal[0]
                    ?.title
                }
                gtmMark={`gtmRedDeAmor${normalizeTwoWords(
                  nombreCategoria
                )}${normalizeTwoWords(
                  gridData.tituloGeneral
                )}${normalizeTwoWords(
                  gridData?.referenciaPlantillaContenido[1]?.tituloBanner
                )}`}
                linkTo={
                  gridData?.referenciaPlantillaContenido[1]?.redireccionBoton
                }
                date={
                  gridData?.referenciaPlantillaContenido[1]?.tituloDescripcion
                }
              />
              <ElementCourse
                title={gridData?.referenciaPlantillaContenido[2]?.tituloBanner}
                info={
                  JSON.parse(
                    gridData?.referenciaPlantillaContenido[2]?.descripcion?.raw
                  )?.content[0]?.content[0]?.value
                }
                imageSrc={
                  gridData?.referenciaPlantillaContenido[2]?.imagenPrincipal[0]
                    ?.gatsbyImageData
                }
                imageAlt={
                  gridData?.referenciaPlantillaContenido[2]?.imagenPrincipal[0]
                    ?.title
                }
                gtmMark={`gtmRedDeAmor${normalizeTwoWords(
                  nombreCategoria
                )}${normalizeTwoWords(
                  gridData.tituloGeneral
                )}${normalizeTwoWords(
                  gridData?.referenciaPlantillaContenido[2]?.tituloBanner
                )}`}
                linkTo={
                  gridData?.referenciaPlantillaContenido[2]?.redireccionBoton
                }
                date={
                  gridData?.referenciaPlantillaContenido[2]?.tituloDescripcion
                }
              />
              <ElementCourse
                title={gridData?.referenciaPlantillaContenido[3]?.tituloBanner}
                info={
                  JSON.parse(
                    gridData?.referenciaPlantillaContenido[3]?.descripcion?.raw
                  )?.content[0]?.content[0]?.value
                }
                imageSrc={
                  gridData?.referenciaPlantillaContenido[3]?.imagenPrincipal[0]
                    ?.gatsbyImageData
                }
                imageAlt={
                  gridData?.referenciaPlantillaContenido[3]?.imagenPrincipal[0]
                    ?.title
                }
                gtmMark={`gtmRedDeAmor${normalizeTwoWords(
                  nombreCategoria
                )}${normalizeTwoWords(
                  gridData.tituloGeneral
                )}${normalizeTwoWords(
                  gridData?.referenciaPlantillaContenido[3]?.tituloBanner
                )}`}
                linkTo={
                  gridData?.referenciaPlantillaContenido[3]?.redireccionBoton
                }
                date={
                  gridData?.referenciaPlantillaContenido[3]?.tituloDescripcion
                }
              />
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GridGroup;
